import { ValidationErrors } from '@angular/forms';

/** Interface generic error message */
export interface ErrorDetails {
  code?: string;
  errorCode?: string;
  errorKey?: string;
  errorMsg?: string;
  fieldName?: string;
  fieldValue?: string;
  infoMessage?: boolean;
  inputReference?: string;
  message?: string;
  reasonCode?: string;
  reasonMsg?: string;
  uiFieldName?: string;
}

/** Interface for a generic error message */
export interface CommonErrorMessage {
  code?: string;
  errorKey?: string;
  message?: string;
  reasonMsg?: string;
}

/** Interface for a generic api/server error */
export interface CommonError {
  details?: ErrorDetails[] | null;
  errorMessage?: string;
  hasDetails?: boolean;
  message?: CommonErrorMessage;
  showError?: boolean;
}

/** Interface for a generic URL
 * The N on uppercase is intentional for match the BFF response cases
 */
export interface Url {
  Name: string;
  value: string;
}

export interface DateOfBirth {
  month: number;
  date: number;
  year: number;
}

export interface Size {
  width: number;
  height: number;
  label: string;
}

export interface EventProperties {
  bubbles: boolean;
  cancelable: boolean;
  detail: string | undefined;
}

export interface ErrorObject {
  fieldname?: string;
  errorValue?: ValidationErrors;
}

export interface DateInfoVO {
  /**
   * day of a date
   */
  day?: number;
  /**
   * hour
   */
  hour?: number;
  /**
   * minute
   */
  minute?: number;
  /**
   * month of a date
   */
  month?: number;
  /**
   * second
   */
  second?: number;
  /**
   * 4-digit year of a date
   */
  year?: number;
}

export type StorageValue =
  | string
  | Record<string, string | number | string[]>
  | boolean;
